/** Header main navigation extras. */
export const COMMON_UI_I18N_PART2_SLICE_H = {
	headerMainNav: {},
} as const;
